<div [class.loading]="loading">
  <h1 *ngIf="content?.title">{{ content.title }}</h1>

  <air-form #formComponent [controls]="form" (submitted)="submitValues($event)" [showMandatory]="true" [userEventSource]="userEventSource">
    <div class="password-reset__button">
      <a (click)="submit($event)" class="button form__button button--cta" [airButtonLoading]="isSubmitting">
        <span>{{ "user.label.confirm_new_password" | translate }}</span>
      </a>
    </div>
  </air-form>
</div>
